import moment from 'moment';

const formatQuery = 'YYYY-MM-DD HH:mm:ss';
const formatHumainQuery = 'DD/MM/YYYY';

const Datetime = {
	getNow: () => {
		return moment().format(formatQuery);
	},
	displayMonth: (datetime) => {
		return moment(datetime).format('MM');
	},
	displayDay: (datetime) => {
		return moment(datetime).format(formatHumainQuery);
	},
	displayDayWithHour: (datetime) => {
		return moment(datetime).format(formatHumainQuery) + ' ' + Datetime.displayHour(datetime);
	},
	displayHour: (datetime) => {
		return moment(datetime).format("HH:mm");
	},
	isValid: (datetime) => {
		let date = moment(datetime);
		return date.isValid();
	}
}

export default Datetime;
